import { useState } from 'react';
import { InspectorControls, } from '@wordpress/block-editor';
import { TabPanel, } from '@wordpress/components';
import { produce } from 'immer';

// Settings Components
import { tabController } from '../../bpl-tools/utils/functions';

import { generalStyleTabs } from './utils/options';
import Elements from './Components/Settings/General/Elements';
import Layout from './Components/Settings/General/Layout';
import Image from './Components/Settings/Style/Image';
import Title from './Components/Settings/Style/Title';
import Creator from './Components/Settings/Style/Creator';
import Licenses from './Components/Settings/Style/Licenses';
import Width from './Components/Settings/Style/Width';

import MediaItems from './Components/Settings/General/MediaItems';

const Settings = ({ attributes, setAttributes }) => {
	const [device, setDevice] = useState('desktop');
	const { columns, columnGap, rowGap, imgBorder, titleTypo, titleColor, creatorTypo, creatorColor, licensesTypo, licensesColor, items, audio, mediaData } = attributes;

	return <>
		<InspectorControls>
			<TabPanel className='bPlTabPanel' activeClass='activeTab' tabs={generalStyleTabs} onSelect={tabController}>{tab => <>
				{'general' === tab.name && <>
					<Elements items={items} setAttributes={setAttributes} />
					<MediaItems items={mediaData} setAttributes={setAttributes} produce={produce} />
					<Layout setAttributes={setAttributes} device={device} setDevice={setDevice} columns={columns} columnGap={columnGap} rowGap={rowGap} />
				</>}

				{'style' === tab.name && <>
					<Image setAttributes={setAttributes} imgBorder={imgBorder} />
					<Title setAttributes={setAttributes} titleTypo={titleTypo} titleColor={titleColor} produce={produce} />
					<Creator setAttributes={setAttributes} creatorTypo={creatorTypo} creatorColor={creatorColor} produce={produce} />
					<Licenses setAttributes={setAttributes} licensesTypo={licensesTypo} licensesColor={licensesColor} produce={produce} />
					<Width setAttributes={setAttributes} audio={audio} />
				</>}
			</>}</TabPanel>
		</InspectorControls>
	</>;
};
export default Settings;